import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import {Apply3Request} from "./types/apply3"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn: body,
          functionCode: "MERC003",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          functionCode: "MERC003",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn : body.tckn,
          TokenSessionId : body.TokenSessionId,
          functionCode: "MERC003",
          NextTransactionUrl: "Facebook/LeadPos/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),    
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn : body.tckn,
          TokenSessionId : body.TokenSessionId,
          functionCode: "MERC003",
          NextTransactionUrl: "Facebook/LeadPos/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),      
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3 : builder.mutation<BaseResponse, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),      
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetConfigListMutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation,useApply3Mutation } = api

export default api
